module.exports = __webpack_public_path__ + "static/media/galeryGrass3.07b206ab.jpg";